import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class PersistanceStorageService {
  constructor() {}
  /*  setStorage: writes a key into localStorage or sessionStorage
    params:
        key <string>     : localStorage or sessionStorage key
        value <string>   : localStorage or sessionStorage value      
    returns:
        <boolean> : telling if operation succeeded
 */
  setStorage(key: string, data: any, storage: string): void {
    try {
      storage === "localstorage"
        ? localStorage.setItem(key, JSON.stringify(data))
        : sessionStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error(`Error saving data to ${storage}`, e);
    }
  }
  /*  getStorage: reads a key from localStorage or sessionStorage
  params:
      key <string>     : localStorage or sessionStorage key
      value <string>   : localStorage value
      expires <number> : number of seconds from now to expire the key
  returns:
      <boolean> : telling if operation succeeded
*/
  getStorage(key: string, storage: string) {
    try {
      return storage === "localstorage"
        ? JSON.parse(localStorage.getItem(key))
        : JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
      console.error(`Error getting data from ${storage}`, e);
      return null;
    }
  }
  /*  deleteStorage: delete a key from localStorage or sessionStorage
  params:
      key <string>     : localStorage or sessionStorage key
      value <string>   : localStorage or sessionStorage value
  returns:
      <boolean> : telling if operation succeeded
*/
  deleteStorage(key: string, storage: string) {
    try {
      storage === "localstorage"
        ? localStorage.removeItem(key)
        : sessionStorage.removeItem(key);
    } catch (e) {
      console.error(`Error removing data from ${storage}`, e);
      return null;
    }
  }
  /*  setStorageWithExpiry: writes a key from localStorage or sessionStorage setting a expire time
  params:
      key <string>     : localStorage key
      value <string>   : localStorage value
      expires <number> : number of seconds from now to expire the key
  returns:
      <boolean> : telling if operation succeeded
*/
  setStorageWithExpiry(key: string, data: any, storage: string, expires) {
    if (expires === undefined || expires === null) {
      expires = 24 * 60 * 60; // default: seconds for 1 day
    } else {
      expires = Math.abs(expires); //make sure it's positive
    }
    let timeNow = Date.now(); //millisecs since epoch time, lets deal only with integer
    let schedule = timeNow + expires * 1000;
    try {
      if (storage === "local") {
        localStorage.setItem(key, JSON.stringify(data));
        localStorage.setItem(key + "_expiresIn", JSON.stringify(schedule));
      } else {
        sessionStorage.setItem(key, JSON.stringify(data));
        sessionStorage.setItem(key + "_expiresIn", JSON.stringify(schedule));
      }
    } catch (e) {
      console.error(
        `setStorage: Error setting key ${key} in ${storage}: ${JSON.stringify(
          e
        )}`
      );
    }
  }
  /*  getStorageWithExpiry: reads a key into localStorage setting a expire time
  params:
      key <string>     : localStorage key
      value <string>   : localStorage value
      expires <number> : number of seconds from now to expire the key
  returns:
      <boolean> : telling if operation succeeded
*/
  getStorageWithExpiry(key: string, storage: string) {
    let timeNow: any = Date.now();
    // set expiration for storage

    let expiresIn: any = localStorage.getItem(key + "_expiresIn");
    if (expiresIn === undefined || expiresIn === null) {
      expiresIn = 0;
    }
    // Expired
    if (expiresIn < timeNow) {
      this.deleteStorage(key, storage);
      return null;
    } else {
      try {
        let value = this.getStorage(key, storage);
        return value;
      } catch (e) {
        console.log(
          `getStorageWithExpiry: Error reading key ${key} from ${storage}: ${JSON.stringify(
            e
          )}`
        );
        return null;
      }
    }
  }
}
